import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import { View } from 'foundations-components/components/View';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMapV2 } from 'self-service-api/constants/ProductLineMap';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import BannerSection from '../components/banners/BannerSection';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import { CreditsCallout } from '../components/common/credits-callout/CreditsCallout';
import Faq from '../components/faqs/Faq';
import Question from '../components/faqs/Question';
import { FreeCard } from '../components/merch-card/cards/FreeCard';
import MobileSuiteFeatureTable from '../components/mobile/MobileSuiteFeatureTable';
import MobileCardWrapper from '../components/mobile/containers/MobileCardWrapper';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { FREE_TOOLS_PAGE, FREE_TOOLS_PAGE_CONTENT } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { ErrorBoundary } from '../v2/components/error-boundary/ErrorBoundary';
import { ERROR_SEVERITY } from '../v2/components/error-boundary/ErrorSeverity';
import withErrorBoundary from '../v2/components/error-boundary/withErrorBoundary';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { FREE_CARD } from '../v2/constants/tracking/TrackingSources';
import { trackPageView } from '../v2/utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileFreeToolsPage = () => {
  useDocumentTitle('crm');
  useEffect(() => {
    trackPageView({
      screen: SCREENS.FREE
    });
  }, []);
  const marketingFreeProduct = FullProductLineMapV2[ProductLines.MARKETING].highlightedFreeProduct;
  const salesFreeProduct = FullProductLineMapV2[ProductLines.SALES].highlightedFreeProduct;
  const serviceFreeProduct = FullProductLineMapV2[ProductLines.SERVICE].highlightedFreeProduct;
  const operationsFreeProduct = FullProductLineMapV2[ProductLines.OPERATIONS].highlightedFreeProduct;
  const cmsFreeProduct = FullProductLineMapV2[ProductLines.CMS].highlightedFreeProduct;
  const commerceFreeProduct = FullProductLineMapV2[ProductLines.COMMERCE].highlightedFreeProduct;
  const productsByProductLine = {
    [ProductLines.MARKETING]: marketingFreeProduct ? [marketingFreeProduct] : [],
    [ProductLines.SALES]: salesFreeProduct ? [salesFreeProduct] : [],
    [ProductLines.SERVICE]: serviceFreeProduct ? [serviceFreeProduct] : [],
    [ProductLines.OPERATIONS]: operationsFreeProduct ? [operationsFreeProduct] : [],
    [ProductLines.CMS]: cmsFreeProduct ? [cmsFreeProduct] : [],
    [ProductLines.COMMERCE]: commerceFreeProduct ? [commerceFreeProduct] : []
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: NavItemEnum.FREE
    }),
    errorBoundaryName: FREE_TOOLS_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    children: /*#__PURE__*/_jsxs(MobileWrapper, {
      navItem: NavItemEnum.FREE,
      navMarkerName: "FREE_TOOLS_PAGE",
      children: [/*#__PURE__*/_jsx(BannerSection, {
        screen: SCREENS.FREE
      }), /*#__PURE__*/_jsxs(PPUIPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.FREE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.FREE
        })]
      }), /*#__PURE__*/_jsxs(PageSection, {
        children: [/*#__PURE__*/_jsx(MobileCardWrapper, {
          children: /*#__PURE__*/_jsx(FreeCard, {
            productLine: "crm",
            columnStart: 1,
            trackingSource: FREE_CARD
          })
        }), /*#__PURE__*/_jsx(View, {
          marginBlock: "800",
          children: /*#__PURE__*/_jsx(CreditsCallout, {
            navItem: SCREENS.FREE
          })
        }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
          productLevel: FREE,
          productsByProductLine: productsByProductLine,
          screen: SCREENS.FREE
        })]
      }), /*#__PURE__*/_jsx(Faq, {
        children: FaqsConfig[NavItemEnum.FREE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        })
      })]
    })
  });
};
export default withErrorBoundary(MobileFreeToolsPage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: FREE_TOOLS_PAGE,
  severity: ERROR_SEVERITY.HIGH
});